import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import 'yet-another-react-lightbox/styles.css';
import Swal from 'sweetalert2';
import { IoMdArrowRoundBack } from "react-icons/io";
import ApiClient from "../../api-client";
import Map from "../Map";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  CardText,
  Button,
  Label,
  Spinner,
  CardImg,
  Badge,
} from "reactstrap";
import { formatedDate } from "../../utils/common";

function CustomerDetails() {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);
  const [alertLoader, setAlertLoader] = useState(false);
  const [userDetails, setUserDetails] = useState(null);
  const [showAlter, setShowAlter] = useState(false);

  const queryParams = new URLSearchParams(location.search);
  const id = queryParams.get("id");

  const fetchDetails = async () => {
    try {
      setLoader(true);
      const getDetails = await ApiClient.get(
        `/users/get-user-by-id/${id}`,
        "",
        true,
        dispatch
      );
      setUserDetails(getDetails.body);
      setLoader(false);
    } catch (error) {
      toast.error(error.message, { autoClose: 3000 });
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchDetails();
  }, []);

  const handleConfirm = async () => {
    if (id) {
      try {
        setAlertLoader(true);
        const verfifyProvider = await ApiClient.put(
          `/admin/update-provider-status`,
          { id },
          true,
          dispatch
        );
        setAlertLoader(false);
        setShowAlter(false);
        fetchDetails();
        toast.success(verfifyProvider.message, { autoClose: 3000 });
      } catch (error) {
        setAlertLoader(false);
        toast.error(error.message, { autoClose: 3000 });
      }
    }
  };

  return (
    <>
      <div className="content">
        <Button
          color="primary"
          className="ml-10 common-button"
          onClick={() => navigate("/admin/customer/list")}
        >
          <IoMdArrowRoundBack /> Back
        </Button>
        <Container>
          {loader && (
            <span className="table-loader">
              <Spinner color="primary">Loading...</Spinner>
            </span>
          )}
          {!loader && (
            <>
              <Card>
                <CardBody className="mb-15">
                  <div>
                    <Row>
                      <Col md="10">
                        <div className="card-heading">
                          <Label>Basic Details</Label>
                        </div>
                      </Col>
                      <Col md="2">
                        {userDetails?.status == "activated" && (
                          <Badge style={{fontSize: '14px'}} color="success" pill>
                            activated
                          </Badge>
                        )}
                        {userDetails?.status == "deactivated" && (
                          <Badge style={{fontSize: '14px', backgroundColor: 'red'}} color="danger" pill>
                            deactivated
                          </Badge>
                        )}
                      </Col>
                    </Row>
                  </div>
                  <div>
                    <Row>
                      <Col md="4" className="profile-card">
                        <img
                          src={
                            userDetails?.profilePic?.url ||
                            require("assets/img/default-avatar.png")
                          }
                          alt="User"
                          className="rounded-circle img-fluid profile-rounded-img"
                        />
                        <CardTitle tag="h5" className="mt-3">
                          {`${userDetails?.firstName} ${userDetails?.lastName}`}
                        </CardTitle>
                      </Col>
                      <Col md="8">
                        <CardBody>
                          <Row className="mt-3">
                            <Col md="4">
                              <strong>First Name:</strong>{" "}
                              {userDetails?.firstName
                                ? userDetails?.firstName
                                : "-"}
                            </Col>
                            <Col md="4">
                              <strong>Last Name:</strong>{" "}
                              {userDetails?.lastName
                                ? userDetails?.lastName
                                : "-"}
                            </Col>
                            <Col md="4">
                              <strong>Phone Number:</strong>{" "}
                              {userDetails?.phoneNumber
                                ? `+27 ${userDetails?.phoneNumber}`
                                : "-"}
                            </Col>
                          </Row>
                          <Row className="mt-3">
                            <Col md="6">
                              <strong>Email:</strong>{" "}
                              {userDetails?.email ? userDetails?.email : "-"}
                            </Col>
                            <Col md="3">
                              <strong>Gender:</strong>{" "}
                              {userDetails?.gender ? userDetails?.gender : "-"}
                            </Col>
                            <Col md="3">
                              <strong>DOB:</strong>{" "}
                              {userDetails?.dateOfBirth
                                ? (formatedDate(userDetails?.dateOfBirth)).split(' ')[0]
                                : "-"}
                            </Col>
                          </Row>
                          <Row className="mt-3">
                            <Col md="6">
                              <strong>Address1:</strong>{" "}
                              {userDetails?.address1
                                ? userDetails?.address1
                                : "-"}
                            </Col>
                            <Col md="6">
                              <strong>Address2:</strong>{" "}
                              {userDetails?.address2
                                ? userDetails?.address2
                                : "-"}
                            </Col>
                          </Row>
                          <Row className="mt-3">
                            <Col md="3">
                              <strong>Pincode:</strong>{" "}
                              {userDetails?.pincode
                                ? userDetails?.pincode
                                : "-"}
                            </Col>
                            <Col md="5">
                              <strong>City:</strong>{" "}
                              {userDetails?.city ? userDetails?.city : "-"}
                            </Col>
                          </Row>
                        </CardBody>
                      </Col>
                    </Row>
                  </div>
                </CardBody>
              </Card>
              <Card>
                <CardBody className="mb-15">
                  <div className="card-heading">
                    <Label>Customer Location</Label>
                    <Map lattitude ={userDetails?.loc?.coordinates[0]} longitude={userDetails?.loc?.coordinates[1]}/>
                  </div>
                </CardBody>
              </Card>
            </>
          )}
          {showAlter && (
            <Swal
              info
              showCancel
              confirmBtnText={
                alertLoader ? (
                  <span>
                    Confirm <Spinner size="sm" />
                  </span>
                ) : (
                  "Confirm"
                )
              }
              confirmBtnBsStyle="info"
              title="Are you sure?"
              onConfirm={handleConfirm}
              onCancel={() => setShowAlter(false)}
              focusCancelBtn
            >
              You want to verfify this service provider
            </Swal>
          )}
        </Container>
      </div>
    </>
  );
}

export default CustomerDetails;
